// extracted by mini-css-extract-plugin
export var Section = "style-module--Section--2k5mo";
export var Heading = "style-module--Heading--1pThg";
export var ContentWrapper = "style-module--ContentWrapper --2GA1D";